import * as React from 'react';
import Typography from '@mui/material/Typography';
import ExtendCard from '../components/ExtendCard';

const AppPage = () => {
    return (
        <span>
            <ExtendCard 
                panelimage=""
                datestring="2022/03/23"
                title="copi-memo 機能説明">
                <Typography variant="body2" color="text.secondary">
                    複雑な操作をなくして、できる限りシンプルな操作にした、<br />
                    コピペツールです。<br /><br />
                </Typography>
            </ExtendCard>
            <br/>

        </span>
    )
}

export default AppPage